export const PatentOfficeNames: Record<string, string> = {
  DE: 'Germany',
  EUIPO: 'European Union',
  WIPO: 'World IP Organization',
};
